import { TextField, alpha, styled } from '@mui/material';

export const StyledTextField = styled(TextField)(({ theme, label }) => ({
  width: '100%',
  marginBottom: theme.spacing(9),
  '& .MuiTextField-root': {
    color: theme.palette.text.secondary,
  },
  '& .MuiInput-root': {
    borderBottom: `1px solid ${theme.palette.primary.main}`,
    '& .Mui-disabled': {
      borderBottom: 'none',
    },
  },
  '&.MuiInputLabel-root': {
    color: theme.palette.primary.main,
  },
  '& .MuiInputBase-input': {
    color: theme.palette.text.secondary,
  },
  '& .MuiInputBase-root.Mui-disabled': {
    color: alpha(theme.palette.common.black, 0.6),
  },
  '& .Mui-disabled': {
    color: theme.palette.primary.main,
    WebkitTextFillColor: `${theme.palette.primary.main}!important`,
    cursor: 'not-allowed',
    border: 'none',
  },
  '& .MuiFormHelperText-root': {
    position: 'absolute',
    top: label ? '50px' : '35px',
  },
  '&label.Mui-focused': {
    color: theme.palette.primary.main,
  },
  '& .MuiInput-underline:after': {
    borderBottomColor: theme.palette.primary.main,
  },
  '& .MuiOutlinedInput-root': {
    '& fieldset': {
      borderColor: 'red',
    },
    '&:hover fieldset': {
      borderColor: 'yellow',
    },
    '&.Mui-focused fieldset': {
      borderColor: 'green',
    },
  },
  '& .Mui-error:after': {
    borderBottom: 'none',
  },
  '& input:-webkit-autofill, input:-webkit-autofill:hover, input:-webkit-autofill:focus, input:-webkit-autofill:active':
    {
      WebkitBoxShadow: `0 0 0 30px ${theme.palette.background.main} inset !important`,
    },
  '& input:-webkit-autofill': {
    WebkitTextFillColor: `${theme.palette.text.secondary} !important`,
  },
  '.MuiInputAdornment-root > p': {
    color: theme.palette.text.secondary,
  },
}));
